import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import TrackingUtils from "@tracking/utils/TrackingUtils";

export const getVariaveis = createAsyncThunk(
  "variaveisApp/variaveis/getVariaveis",
  async (data: object, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/variaveis", {
        params: data,
      });
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar as variáveis!",
          text: TrackingUtils.getErrorMessagesFromApi(err.data),
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const saveVariavel = createAsyncThunk(
  "variaveisApp/variaveis/saveVariavel",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/variaveis", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Variável cadastrada",
        })
      );
      dispatch(
        getVariaveis(requestGetParams.variaveisApp.variaveis.requestGetParams)
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar a variável!",
          text: TrackingUtils.getErrorMessagesFromApi(err.data),
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const editVariavel = createAsyncThunk(
  "variaveisApp/variaveis/editVariavel",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/variaveis", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Variável editada",
        })
      );
      dispatch(
        getVariaveis(requestGetParams.variaveisApp.variaveis.requestGetParams)
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível editar a variável!",
          text: TrackingUtils.getErrorMessagesFromApi(err.data),
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const deleteVariavel = createAsyncThunk(
  "variaveisApp/variaveis/deleteVariavel",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idCodigo } = data;
    try {
      await API.delete(`/variaveis/${idCodigo}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Variável removida",
        })
      );
      dispatch(
        getVariaveis(requestGetParams.variaveisApp.variaveis.requestGetParams)
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível remover a variável!",
          text: TrackingUtils.getErrorMessagesFromApi(err.data),
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);
